import moment from 'moment';
import { admission_co_type, co_acceptance_type, co_witness_type, cr_acceptance_type, cr_witness_type, formatInitialValue, guest_checkin_type, guest_checkout_type, pdpa_co_type, prefilledData, staff_checkin_type, staff_checkout_type } from './common_use';

//step 1
export const admissionStates = {
    date_of_admission: null,
    room_assigned: '',
    cr_name: '',
    cr_ic_passport: '',
    cr_mobile: "",
    cr_address: '',
    cr_height: '',
    cr_ambulatory: '',
    cr_language: '',
    cr_gender: '',
    cr_dob: null,
    cr_age: '',
    cr_email: '',
    cr_weight: '',
    co_name: '',
    co_ic_passport: '',
    co_mobile: '',
    co_address: '',
    co_gender: '',
    co_dob: null,
    co_special_note: '',
    attachments: [],

    //need checking
    diapers: '',
    medications: '',
    milkPowder: '',


    follow_up_hospital: '',
    follow_up_doctor_name: '',
    follow_up_doctor_contact: '',

    emergency_hospital: '',
    emergency_special_instruction: '',
    emergency_name: '',
    emergency_contact: '',
    emergency_relationship: '',

    signatures: [
        {
            type: admission_co_type,
            name: '',
            ic_passport: '',
            signature_url_s3: ''
        },
        {
            type: staff_checkin_type,
            name: '',
            date: null,
            position: '',
            signature_url_s3: ''
        },
        {
            type: guest_checkin_type,
            signature_url_s3: '',
        },
        {
            type: staff_checkout_type,
            name: '',
            date: null,
            position: '',
            signature_url_s3: ''
        },
        {
            type: guest_checkout_type,
            signature_url_s3: ''
        },
        {
            type: cr_acceptance_type,
            name: '',
            ic_passport: '',
            date: null,
            signature_url_s3: ''
        },
        {
            type: cr_witness_type,
            name: '',
            ic_passport: '',
            date: null,
            signature_url_s3: ''
        },
        {
            type: co_acceptance_type,
            name: '',
            ic_passport: '',
            date: null,
            signature_url_s3: ''
        },
        {
            type: co_witness_type,
            name: '',
            ic_passport: '',
            date: null,
            signature_url_s3: ''
        },
        {
            type: pdpa_co_type,
            name: '',
            ic_passport: '',
            date: null,
            signature_url_s3: ''
        }
    ],

    //schedule1
    date_of_agreement: moment(),
    services: formatInitialValue(prefilledData),
    term: '',
    commencement_date: moment(),
    security_deposit: 'A sum equivalent to [1] months(s) Service Fee',

    //schedule2
    room_type: '',
    price_per_month: '',
    deposit: '',
    services_schedule_2: '',
    others: '',
    total: '',
    commencement_date_schedule_2: moment(),
    payment_terms: '',

    //schedule3
    //inventories: items,
    inventories: []
};